import Image from "next/image";
import React, { useState } from "react";
import { GoArrowLeft } from "react-icons/go";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { MdContentCopy } from "react-icons/md";
import { RxReload } from "react-icons/rx";
import { ClipLoader } from "react-spinners";
import { APIResponseDataProps } from ".";
import { TemplateGeneratorFormInputProps } from "./TemplateGeneratorForm";

interface TemplatePreviewProps {
    formData: TemplateGeneratorFormInputProps;
    previewData: APIResponseDataProps;
    messageContent: string | JSX.Element;
    onGenerate: (data: TemplateGeneratorFormInputProps) => void;
    showRegenerateBtn: boolean;
    isRegeneratingTemplate: boolean;
}

const TemplatePreview: React.FC<TemplatePreviewProps> = (props) => {
    const { formData, previewData, messageContent, onGenerate, showRegenerateBtn, isRegeneratingTemplate } = props;

    const [clipboardText, setClipboardText] = useState("Copy");

    const copyTemplate = () => {
        const copyTemplateText = `${previewData.header ?? ""}\n\n  ${previewData.body}\n\n  ${previewData.footer ?? ""}`;
        navigator.clipboard.writeText(copyTemplateText);
        setClipboardText("Copied !");
    };

    const handleRegeneration = (formData: TemplateGeneratorFormInputProps) => {
        try {
            onGenerate({ ...formData, loadingState: "regenerate" });
            setClipboardText("Copy");
        } catch (error) {
            console.log("error", error);
        }
    };

    const messageBody = (
        <div className="p-5 rounded-b-xl">
            <p className="relative sidevector bg-white rounded-xl shadow-lg text-base text-black p-4 ">{messageContent}</p>
            <div className="pt-4 flex justify-end gap-2">
                {showRegenerateBtn && (
                    <button
                        className="flex gap-2 p-2 text-base font-medium text-gray-500 bg-white border border-solid border-gray-400 rounded-lg hover:shadow-md hover:bg-gray-50 focus:outline-none"
                        onClick={() => handleRegeneration(formData)}
                    >
                        {isRegeneratingTemplate ? (
                            <div className="flex gap-1 items-center justify-center bg-gray-50">
                                <ClipLoader color={"#6b7280"} loading={true} size={20} />
                                <p>Regenerating</p>
                            </div>
                        ) : (
                            <>
                                <RxReload size="20px" />
                                Regenerate
                            </>
                        )}
                    </button>
                )}
                <button
                    className="flex gap-2 p-2 text-base font-medium text-white bg-green-400 border border-solid border-green-500 rounded-lg hover:shadow-md hover:bg-green-500 focus:outline-none"
                    onClick={copyTemplate}
                >
                    <MdContentCopy size="20px" /> {clipboardText}
                </button>
            </div>
        </div>
    );

    return (
        <>
            <div className="lg:block md:block hidden lg:w-1/2 w-full px-20 py-6 bg-green-50 text-white rounded-2xl" style={{ minHeight: "760px" }}>
                <div className="sticky top-20">
                    <div className="p-4 flex items-center justify-between rounded-t-xl" style={{ backgroundColor: "#008069" }}>
                        <div className="flex items-center gap-2 ">
                            <GoArrowLeft size="30px" />
                            <div className="bg-white w-12 h-12 flex items-center justify-center rounded-full">
                                <Image width={26} height={26} src="/gallabox-icon.png" alt="gallabox icon" />
                            </div>
                            <div>
                                <div className="flex items-center gap-1">
                                    <p className="text-base font-bold overflow-hidden truncate" style={{ maxWidth: "175px" }}>
                                        {formData.businessName}
                                    </p>
                                    <Image
                                        src="https://assets.gallabox.com/gb-home/home-page/testimony/verified-green-tick.png"
                                        alt="Verified green tick"
                                        width={17}
                                        height={17}
                                        loading="lazy"
                                    />
                                </div>
                                <p className="text-base font-normal">Business Account</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-2">
                            <div style={{ width: "22px", height: "17px" }}>
                                <Image width={22} height={17} src="/ai-whatsapp-template-generator/Form/preview/market-store-icon.png" alt="Marketplace" />
                            </div>
                            <HiOutlineDotsVertical size="22px" />
                        </div>
                    </div>
                    <div
                        className="rounded-b-xl"
                        style={{ backgroundImage: "url(https://assets.gallabox.com/gb-home/ai-whatsapp-template-generator/form-preview/wa-background.png)", minHeight: "400px" }}
                    >
                        {messageBody}
                    </div>
                </div>
            </div>
            <div className="lg:hidden md:hidden block px-2 py-6 bg-green-50 text-white rounded-2xl">{messageBody}</div>
        </>
    );
};

export default TemplatePreview;
